import {
    MantineProvider,
    AppShell,
    CSSVariablesResolver,
    Flex,
    Group,
    Pagination,
    Loader,
    Button,
    Text,
    Center,
    Divider,
    createTheme,
    ThemeIcon,
    Menu,
    Title,
    rem,
    Image,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useViewportSize, usePagination } from "@mantine/hooks";
import Details from "./Details";
import Highlights from "./Highlights";
import Day from "./Day";
import Summary from "./Summary";
import Book from "./Book";
import { NextIcon } from "../../Components/next_icon";
import {
    useNavigate,
    BrowserRouter,
    Link,
    Route,
    Routes,
    useParams,
    Navigate,
} from "react-router-dom";
import { set } from "lodash";
import { Animate } from "react-simple-animate";
import { CiCircleChevRight, CiCircleChevLeft } from "react-icons/ci";
import { FaChevronDown } from "react-icons/fa";
import { FaCircleChevronLeft, FaCircleChevronRight } from "react-icons/fa6";
{
    /* <style>
    @import
    url('https://fonts.googleapis.com/css2?family=Abril+Fatface&family=PT+Sans&display=swap');
</style>; */
}

function navigatePage() {}
export default function Main() {
    const [tour, setTour] = useState(null);
    const { height, width } = useViewportSize();
    const [activePage, setPage] = useState(null);
    const navigate = useNavigate();
    const params = useParams();
    const [component, setComponent] = useState(null);
    const [nextPage, setNextPage] = useState(false);
    const [currentPage, setCurrentPage] = useState(null);

    let page = null;
    useEffect(() => {
        fetch("/tours/get/" + params.tour_id)
            .then((res) => res.json())
            .then(
                (result) => {
                    setTour(result);
                    console.log(result);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {}
            );
        // navigate(params["*"]);
    }, []);
    // const lightGrey: MantineColorsTuple = [];
    useEffect(() => {
        if (tour != null) {
            if (activePage == null) {
                switch (params.page) {
                    case "highlights":
                        setPage(3);
                        break;
                    case "details":
                        setPage(2);
                        break;
                    case "intro":
                        setPage(1);
                        break;
                    case "summary":
                        setPage(tour.tour.tour_days.length + 4);
                        break;
                    case "day":
                        setPage(parseInt(params.day) + 3);
                        break;
                }
            }
            if (activePage == tour.tour.tour_days.length + 4) {
                setComponent(<Summary tour={tour} />);
                navigate("/brochure/" + params.tour_id + `/summary`);
                // component = <Summary tour={tour} />;
            } else if (activePage > 3) {
                setComponent(
                    <Day tour={tour} key={activePage} day={activePage - 3} />
                );
                navigate(
                    "/brochure/" + params.tour_id + `/day/${activePage - 3}`
                );
                // component = <Day tour={tour} />;
            } else if (activePage == 3) {
                navigate("/brochure/" + params.tour_id + `/highlights`);
                // component = <Highlights tour={tour} />;
                setComponent(<Highlights tour={tour} />);
            } else if (activePage == 2) {
                navigate(`/brochure/${params.tour_id}/details`);
                // component = <Details tour={tour} />;
                setComponent(<Details tour={tour} />);
            } else if (activePage == 1) {
                navigate(`/brochure/${params.tour_id}/intro`);
            } else {
                if (params.day) {
                    navigate(`/brochure/${params.tour_id}/${params.day}`);
                }
            }
        }
    }, [activePage, tour]);

    const theme = createTheme({
        fontFamily: "PT Sans,Abril Fatface, sans-serif",

        colors: {
            grey: [
                "#e2e4e2",
                "#cbcdcb",
                "#b5b6b5",
                "#9ea09e",
                "#888988",
                "#717271",
                "#5a5b5a",
                "#444444",
                "#2d2e2d",
                "#171717",
            ],
            purple: [
                "#57345b",
                "#4e2f52",
                "#462a49",
                "#3d2440",
                "#341f37",
                "#2c1a2e",
                "#231524",
                "#1a101b",
                "#110a12",
                "#090509",
            ],
        },
        primaryColor: "purple",
        shadows: {
            md: "1px 1px 3px rgba(0, 0, 0, .25)",
            xl: "5px 5px 3px rgba(0, 0, 0, .25)",
        },
        color: "purple",
        breakpoints: {
            xs: "30em",
            sm: "48em",
            md: "64em",
            lg: "74em",
            xl: "90em",
        },
        fontSizes: {
            xs: rem(12),
            sm: rem(14),
            md: rem(16),
            lg: rem(20),
            xl: rem(24),
        },
        headings: {
            fontFamily: "Abril Fatface,PT Sans, sans-serif",
        },
    });

    return (
        <MantineProvider theme={theme}>
            <AppShell
                padding="md"
                h={height}
                header={{ height: 110 }}
                footer={{ height: 60 }}
                styles={(theme) => ({
                    main: {
                        backgroundColor:
                            theme.colorScheme === "dark"
                                ? theme.colors.dark[8]
                                : theme.colors.gray[0],
                    },
                })}
                c={"purple.0"}
            >
                <AppShell.Header bg="grey.0" p="xs">
                    <Flex justify="space-between" align="center" h={"100%"}>
                        <Flex justify="flex-start" align="flex-center">
                            <Image
                                className="header-image"
                                src="/img/BST-logo-colour.png"
                                alt="logo"
                            />
                            <Image
                                visibleFrom="md"
                                className="header-image"
                                src="/img/SPTA-2023.png"
                                alt="logo"
                            />
                            <Image
                                visibleFrom="md"
                                className="header-image"
                                src="/img/TA-5star.png"
                                alt="logo"
                            />
                        </Flex>
                        <Flex justify="flex-end" align="flex-center">
                            {tour == null ? (
                                <Loader size={50} />
                            ) : (
                                <Group visibleFrom="md" pr={100}>
                                    <Text
                                        onClick={() => {
                                            setPage(2);
                                        }}
                                        style={
                                            activePage == 2
                                                ? {
                                                      fontWeight: "bold",
                                                      cursor: "pointer",
                                                  }
                                                : {
                                                      fontWeight: "normal",
                                                      cursor: "pointer",
                                                  }
                                        }
                                    >
                                        Summary
                                    </Text>
                                    <Divider size="sm" orientation="vertical" />
                                    <Text
                                        onClick={() => {
                                            setPage(3);
                                        }}
                                        style={
                                            activePage == 3
                                                ? {
                                                      fontWeight: "bold",
                                                      cursor: "pointer",
                                                  }
                                                : {
                                                      fontWeight: "normal",
                                                      cursor: "pointer",
                                                  }
                                        }
                                    >
                                        Highlights
                                    </Text>
                                    <Divider size="sm" orientation="vertical" />
                                    <Menu
                                        trigger="hover"
                                        width={100}
                                        shadow="md"
                                    >
                                        <Menu.Target>
                                            <Text
                                                style={
                                                    activePage > 3 &&
                                                    activePage <
                                                        tour.tour.tour_days
                                                            .length +
                                                            4
                                                        ? {
                                                              fontWeight:
                                                                  "bold",
                                                              cursor: "pointer",
                                                          }
                                                        : {
                                                              fontWeight:
                                                                  "normal",
                                                              cursor: "pointer",
                                                          }
                                                }
                                            >
                                                Days <FaChevronDown />
                                            </Text>
                                        </Menu.Target>
                                        <Menu.Dropdown>
                                            {tour.tour.tour_days.map((day) => {
                                                return (
                                                    <Center>
                                                        <Text
                                                            onClick={() => {
                                                                setPage(
                                                                    parseInt(
                                                                        day.day_no
                                                                    ) + 3
                                                                );
                                                            }}
                                                            style={
                                                                activePage ==
                                                                parseInt(
                                                                    day.day_no
                                                                ) +
                                                                    3
                                                                    ? {
                                                                          fontWeight:
                                                                              "bold",
                                                                          cursor: "pointer",
                                                                      }
                                                                    : {
                                                                          fontWeight:
                                                                              "normal",
                                                                          cursor: "pointer",
                                                                      }
                                                            }
                                                        >
                                                            Day {day.day_no}
                                                        </Text>
                                                    </Center>
                                                );
                                            })}
                                        </Menu.Dropdown>
                                    </Menu>
                                    <Divider size="sm" orientation="vertical" />
                                    <Text
                                        onClick={() => {
                                            setPage(
                                                tour.tour.tour_days.length + 4
                                            );
                                        }}
                                        style={
                                            activePage ==
                                            tour.tour.tour_days.length + 4
                                                ? {
                                                      fontWeight: "bold",
                                                      cursor: "pointer",
                                                  }
                                                : {
                                                      fontWeight: "normal",
                                                      cursor: "pointer",
                                                  }
                                        }
                                    >
                                        Book
                                    </Text>
                                </Group>
                            )}
                        </Flex>
                    </Flex>
                </AppShell.Header>
                <AppShell.Footer
                    bg="purple.0"
                    p="xs"
                    style={{ color: "white" }}
                >
                    {tour == null ? (
                        <Loader size={50} />
                    ) : (
                        <Flex justify="space-between" align="center">
                            <Text>
                                {activePage} / {tour.tour.tour_days.length + 4}
                            </Text>

                            <Pagination.Root
                                total={tour.tour.tour_days.length + 4}
                                value={activePage}
                                onChange={(page) => {
                                    setNextPage(true);
                                    setCurrentPage(page);
                                }}
                            >
                                <Group gap="5" justify="center">
                                    <Text>Previous</Text>
                                    <Pagination.Previous icon={previousIcon} />

                                    <Pagination.Next icon={nextIcon} />
                                    <Text>Next</Text>
                                </Group>
                            </Pagination.Root>
                            <Button radius="10px" className="book-button">
                                Book my trip
                            </Button>
                        </Flex>
                    )}
                </AppShell.Footer>
                <AppShell.Main pt={100} h={height - 163}>
                    <Animate
                        play={nextPage}
                        start={{
                            opacity: 1,
                        }}
                        end={{ opacity: 0.1 }}
                        duration={0.2}
                        onComplete={() => {
                            setPage(currentPage);
                            setNextPage(false);
                            console.log(currentPage);
                        }}
                    >
                        {component}
                    </Animate>
                </AppShell.Main>
            </AppShell>
        </MantineProvider>
    );
}

function nextIcon() {
    return (
        <ThemeIcon color="purple.0">
            <FaCircleChevronRight style={{ width: rem(30), height: rem(30) }} />
        </ThemeIcon>
    );
}
function previousIcon() {
    return (
        <ThemeIcon color="purple.0">
            <FaCircleChevronLeft style={{ width: rem(30), height: rem(30) }} />
        </ThemeIcon>
    );
}
